import React from "react";

const YouTubeVideoCarousel = ({ videos = [] }) => {
  return (
    <section className="bg-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-[#003366] mb-8 text-center">
          Explore Our Video Insights
        </h2>

        <div className="overflow-x-auto">
          <div className="flex gap-6 min-w-full pb-4">
            {videos.map((videoUrl, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[300px] sm:w-[360px] md:w-[420px] rounded-lg shadow-md border border-gray-200"
              >
                <div className="aspect-video w-full h-full">
                  <iframe
                    src={videoUrl}
                    title={`Video ${index + 1}`}
                    className="w-full h-full rounded-lg"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouTubeVideoCarousel;
